export enum GridCellStatus {
  Pending = "Pending",
  Deleted = "Deleted",
  Completed = "Completed",
  RegistrationStarted = "RegistrationStarted",

  Enabled = "Enabled",
  Disabled = "Disabled"
}
